module.exports = __webpack_public_path__ + "img/line-manager.790c4ee6.svg";